import React from "react";
import Box from "@mui/material/Box";
import { keyframes } from "@emotion/react";
import { lspsStatus } from "./lspsSwitch";

const pulse = keyframes`0%, 100% { opacity: 1; } 50% { opacity: 0.35; }`;

// The design's status pill (NEU-697): grey Off, amber Standby, green Active with a pulsing pip.
const TONES = {
  off: { bg: "#222A35", color: "rgba(255,255,255,0.65)", border: "rgba(255,255,255,0.12)", pip: "rgba(255,255,255,0.3)" },
  standby: { bg: "rgba(245,158,11,0.14)", color: "#FCD34D", border: "rgba(245,158,11,0.3)", pip: "#FDB940" },
  active: { bg: "rgba(34,197,94,0.12)", color: "#86EFAC", border: "rgba(34,197,94,0.3)", pip: "#22C55E" },
};

export default function LSPSStatusChip({ name, on, active }) {
  const status = lspsStatus(on, active);
  const tone = TONES[status.tone];
  return (
    <Box
      component="span"
      title={`${name}: ${status.title}`}
      sx={{
        display: "inline-flex", alignItems: "center", gap: "5px", px: "9px", py: "3px",
        borderRadius: "999px", fontSize: "0.72rem", fontWeight: 500, lineHeight: 1.4,
        bgcolor: tone.bg, color: tone.color, border: `1px solid ${tone.border}`, whiteSpace: "nowrap",
      }}
    >
      <Box
        component="span"
        sx={{
          width: 6, height: 6, borderRadius: "50%", bgcolor: tone.pip,
          animation: status.tone === "active" ? `${pulse} 1.6s infinite` : "none",
          "@media (prefers-reduced-motion: reduce)": { animation: "none" },
        }}
      />
      {status.label}
    </Box>
  );
}
